import type { GeneratedFile } from "../../files/cached/GeneratedFile"
import type { RemoteFile } from "../../files/cached/RemoteFile"
import type { TaskBase } from "../base/TaskBase"
import type { TaskName } from "../TaskName"

export type TaskSplitOptions = {
  readonly enum: TaskName.TASK_SPLIT
  readonly source: GeneratedFile | RemoteFile
} & TaskBase
